import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-night py-16 text-white md:py-24" data-id="element-14" data-mp="pjg5c01zr60e">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-15" data-mp="avv3e9gurcu2">
        <header className="mx-auto max-w-narrow text-center" data-id="element-16" data-mp="fu6cghzbpjb8">
          <h2 className="inline-flex flex-wrap items-center justify-center gap-3 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-amber-400 md:text-5xl" data-id="element-17" data-mp="fslj2voqw6ey">
            <GiftIcon className="h-8 w-8 md:h-10 md:w-10" aria-hidden="true" data-id="element-18" data-mp="5x1lm4uj8zo3" />
            Bonos exclusivos
          </h2>
          <p className="mt-5 text-lg text-gray-300 md:text-xl" data-id="element-19" data-mp="3o36canz55gkh">
            Solo por esta campaña, incluidos sin costo con tu Protocolo.
          </p>
        </header>

        <ul className="mt-12 grid gap-5 md:mt-16 lg:grid-cols-3" data-id="element-20" data-mp="1m9ysb18l2as9">
          {bonuses.map(bonus => <li key={bonus.tag} className="flex h-full flex-col rounded-2xl bg-gray-900 p-6 ring-1 ring-gray-800 md:p-7" data-id="element-21" data-mp="1r8a6tp9tp9gt">
              <span className="inline-flex w-fit items-center rounded-lg bg-amber-400 px-3 py-1 font-display text-xs font-extrabold uppercase tracking-[0.12em] text-night" data-id="element-22" data-mp="3dfd5ls9xsgx3">
                {bonus.tag}
              </span>
              <h3 className="mt-5 font-display text-xl font-extrabold leading-snug tracking-tight text-white" data-id="element-23" data-mp="3n4wkynyfxsn7">
                {bonus.title}
              </h3>
              <p className="mt-1 font-display text-sm font-bold text-amber-400" data-id="element-24" data-mp="2zhf1dfpby0vb">{bonus.subtitle}</p>
              <p className="mt-4 text-gray-300" data-id="element-25" data-mp="2uiu1xihwjl7x">{bonus.lead}</p>

              <ul className="mt-5 space-y-2.5" data-id="element-26" data-mp="38htp0lprns1z">
                {bonus.includes.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-gray-200" data-id="element-27" data-mp="33fm6fdafldqo">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-grass-400" aria-hidden="true" data-id="element-28" data-mp="noq6mx4nxr09" />
                    <span data-id="element-29" data-mp="3cjfylch1gpix">{item}</span>
                  </li>)}
              </ul>

              <p className="mt-auto flex items-center gap-3 pt-7" data-id="element-30" data-mp="3hhhsytjx0b9p">
                <span className="text-sm text-gray-500 line-through" data-id="element-31" data-mp="3hk3w8gzrw4m4">Valor: {bonus.value}</span>
                <span className="rounded-lg bg-grass-500/15 px-3 py-1 font-display text-sm font-extrabold uppercase text-grass-400 ring-1 ring-grass-500/40" data-id="element-32" data-mp="3lhi3w47t24c0">
                  Incluido
                </span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}